<template>
  <div class="single_container">
    <div class="personalMainHead">
      <PersonalHead
        type="initiation_single"
        :titleName="titleName"
        :titleNamePrefix="titleNamePrefix"
        :backPath="personalHeadBackPath"
      ></PersonalHead>
    </div>
    <Loading v-show="isLoading" />

    <div class="info_box">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="120px"
        class="task_form"
      >
        <div class="item">
          <div class="label">
            <div class="line"></div>
            <div>债权人信息</div>
          </div>
          <el-row class="fq-data">
            <el-col span="8">
              <el-form-item label="机构名称：">
                <div class="gray">{{ fqData.enterpriseName || "-" }}</div>
              </el-form-item>
            </el-col>
            <el-col span="8">
              <el-form-item label="机构代码：">
                <div class="gray">{{ fqData.organizationCode || "-" }}</div>
              </el-form-item>
            </el-col>
            <el-col span="8">
              <el-form-item label="法人姓名：">
                <div class="gray">{{ fqData.legalPersonName || "-" }}</div>
              </el-form-item>
            </el-col>
            <el-col span="8">
              <el-form-item label="法人证件号：">
                <div class="gray">
                  {{ fqData.legalPersonIdcardNumber || "-" }}
                </div>
              </el-form-item>
            </el-col>
            <el-col span="16">
              <el-form-item label="机构地址：">
                <div class="gray">
                  {{ fqData.provinceName || "" }}{{ fqData.cityName || ""
                  }}{{ fqData.areaName || ""
                  }}{{ fqData.enterpriseAddress || "" }}
                </div>
              </el-form-item>
            </el-col>
            <el-col span="8">
              <el-form-item label="代理人：">
                <div class="gray">{{ fqData.person.realName || "-" }}</div>
              </el-form-item>
            </el-col>
            <el-col span="8">
              <el-form-item label="代理人证件号：">
                <div class="gray">{{ fqData.person.idcardNumber || "-" }}</div>
              </el-form-item>
            </el-col>
            <el-col span="8">
              <el-form-item label="代理人手机号：">
                <div class="gray">{{ fqData.person.mobile || "-" }}</div>
              </el-form-item>
            </el-col>
            <el-col span="8">
              <el-form-item label="代理类型：">
                <div class="gray">特别授权代理人</div>
              </el-form-item>
            </el-col>
            <el-col span="8">
              <el-form-item label="代理人身份：">
                <div class="gray">机构职员</div>
              </el-form-item>
            </el-col>
            <el-col span="8">
              <el-form-item label="代理期限：">
                <div class="gray">2024年11月1日至2025年10月31日</div>
              </el-form-item>
            </el-col>

            <el-col
              :span="item.span ? item.span : 8"
              v-for="(item, index) in zqrVariablList"
              :key="index"
            >
              <el-form-item
                class="nameContract"
                :label="item.nameValue + '：'"
                :prop="item.sourceProprety"
                :rules="[
                  {
                    required: item.notNull,
                    message: item.title,
                    trigger: 'blur',
                  },
                  {
                    pattern: new RegExp(item.valueCheckConstraint),
                    message: '格式错误',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  v-if="item.valueDisplayType == 1"
                  v-model="form[item.sourceProprety]"
                  :placeholder="item.title"
                  :maxlength="item.maxlen"
                  @blur="zwrStoreData(item.sourceProprety)"
                  size="small"
                  clearable
                ></el-input>
                <el-select
                  v-if="item.valueDisplayType == 2"
                  v-model="form[item.sourceProprety]"
                  :placeholder="item.title"
                  size="small"
                  style="width: 100%"
                >
                  <el-option
                    :label="items.value"
                    :value="items.id + ''"
                    v-for="(items, indexs) in item.paramsList"
                    :key="indexs"
                  ></el-option>
                </el-select>
                <template v-if="item.valueDisplayType == 3">
                  <el-checkbox-group
                    v-model="form[item.sourceProprety]"
                    size="small"
                    clearable
                  >
                    <el-checkbox
                      v-for="(i, ind) in item.paramsList"
                      :key="ind"
                      :label="item.value"
                    ></el-checkbox>
                  </el-checkbox-group>
                </template>
                <template v-if="item.valueDisplayType == 4">
                  <el-date-picker
                    type="date"
                    :placeholder="item.title"
                    v-model="form[item.sourceProprety]"
                    :clearable="false"
                    value-format="yyyy-MM-dd"
                    size="small"
                  ></el-date-picker>
                </template>
                <template v-if="item.valueDisplayType == 5">
                  <el-select
                    v-model="form[item.sourceProprety]"
                    :placeholder="item.title"
                    size="small"
                  >
                    <el-option
                      :label="items"
                      :value="items"
                      v-for="(items, indexs) in 31"
                      :key="indexs"
                    ></el-option>
                  </el-select>
                </template>
                <el-radio-group
                  v-if="item.valueDisplayType == 6"
                  v-model="form[item.sourceProprety]"
                  :placeholder="item.title"
                  size="small"
                >
                  <el-radio
                    :label="items.key"
                    :value="items.key + ''"
                    v-for="(items, indexs) in item.paramsList"
                    :key="indexs"
                    >{{ items.value }}</el-radio
                  >
                </el-radio-group>
                <el-input
                  v-if="item.valueDisplayType == 88"
                  v-model="form[item.sourceProprety]"
                  :placeholder="item.title"
                  :maxlength="item.maxlen"
                  size="small"
                  type="textarea"
                  rows="3"
                  resize="none"
                ></el-input>
                <div class="formItemDscp" v-if="item.unit">
                  单位：{{ item.unit }}
                </div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <!-- <el-form-item label="合同名称：" prop="contractName">
              <el-input
                clearable
                placeholder="请输入合同名称"
                v-model="form.contractName"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="签署顺序：" label-width="130px" prop="fqWell">
              <el-radio-group v-model="form.fqWell">
                <el-radio :label="0">债权人先签署</el-radio>
                <el-radio :label="1">债务人先签署</el-radio>
                <el-radio :label="2">无顺序</el-radio>
              </el-radio-group>
            </el-form-item> -->
          </el-row>
        </div>
        <div class="item">
          <div class="label">
            <div class="line"></div>
            <div>债务人信息</div>
          </div>
          <el-row>
            <el-col
              :span="item.span ? item.span : 8"
              v-for="(item, index) in zwrVariablList"
              :key="index"
            >
              <el-form-item
                class="nameContract"
                :label="item.nameValue + '：'"
                :prop="item.sourceProprety"
                :rules="[
                  {
                    required: item.notNull,
                    message: item.title,
                    trigger: 'blur',
                  },
                  {
                    pattern: new RegExp(item.valueCheckConstraint),
                    message: '格式错误',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  v-if="item.valueDisplayType == 1"
                  v-model="form[item.sourceProprety]"
                  :placeholder="item.title"
                  :maxlength="item.maxlen"
                  @blur="zwrStoreData(item.sourceProprety)"
                  size="small"
                  clearable
                ></el-input>
                <el-select
                  v-if="item.valueDisplayType == 2"
                  v-model="form[item.sourceProprety]"
                  :placeholder="item.title"
                  size="small"
                  clearable
                >
                  <el-option
                    :label="items.value"
                    :value="items.id + ''"
                    v-for="(items, indexs) in item.paramsList"
                    :key="indexs"
                  ></el-option>
                </el-select>
                <template v-if="item.valueDisplayType == 3">
                  <el-checkbox-group
                    v-model="form[item.sourceProprety]"
                    size="small"
                    clearable
                  >
                    <el-checkbox
                      v-for="(i, ind) in item.paramsList"
                      :key="ind"
                      :label="item.value"
                    ></el-checkbox>
                  </el-checkbox-group>
                </template>
                <template v-if="item.valueDisplayType == 4">
                  <el-date-picker
                    type="date"
                    :placeholder="item.title"
                    v-model="form[item.sourceProprety]"
                    :clearable="false"
                    value-format="yyyy-MM-dd"
                    size="small"
                  ></el-date-picker>
                </template>
                <template v-if="item.valueDisplayType == 5">
                  <el-select
                    v-model="form[item.sourceProprety]"
                    :placeholder="item.title"
                    size="small"
                    clearable
                  >
                    <el-option
                      :label="items"
                      :value="items"
                      v-for="(items, indexs) in 31"
                      :key="indexs"
                    ></el-option>
                  </el-select>
                </template>
                <el-radio-group
                  v-if="item.valueDisplayType == 6"
                  v-model="form[item.sourceProprety]"
                  :placeholder="item.title"
                  size="small"
                >
                  <el-radio
                    :label="items.key"
                    :value="items.key + ''"
                    v-for="(items, indexs) in item.paramsList"
                    :key="indexs"
                    >{{ items.value }}</el-radio
                  >
                </el-radio-group>
                <el-input
                  v-if="item.valueDisplayType == 88"
                  v-model="form[item.sourceProprety]"
                  :placeholder="item.title"
                  :maxlength="item.maxlen"
                  size="small"
                  type="textarea"
                  rows="3"
                  resize="none"
                  clearable
                ></el-input>
                <div class="formItemDscp" v-if="item.unit">
                  单位：{{ item.unit }}
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-form-item label="姓名：" prop="bgName">
              <el-input
                clearable
                placeholder="请输入姓名"
                v-model="form.bgName"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="身份证号："
              label-width="150px"
              prop="bgCardNo"
            >
              <el-input
                clearable
                v-model="form.bgCardNo"
                placeholder="请输入身份证号"
                size="small"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="手机号：" prop="bgMobile">
              <el-input
                clearable
                v-model="form.bgMobile"
                placeholder="请输入手机号"
                size="small"
                @blur="savePerson"
              ></el-input>
            </el-form-item>
            <el-form-item label="电子邮箱：" label-width="150px" prop="bgMail">
              <el-input
                clearable
                v-model="form.bgMail"
                placeholder="请输入电子邮箱"
                size="small"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="实际联系地址：" prop="bgCitys">
              <Cascader :key="form.bgCitys" v-model="form.bgCitys" />
            </el-form-item>
            <el-form-item label-width="20px" prop="bgAddress">
              <el-input
                clearable
                placeholder="请输入详细地址"
                v-model="form.bgAddress"
                size="small"
              ></el-input>
            </el-form-item>
          </el-row> -->
        </div>
        <div class="item">
          <div class="label">
            <div class="line"></div>
            <div>合同信息</div>
          </div>
          <el-row>
            <el-col
              :span="item.span ? item.span : 8"
              v-for="(item, index) in variablList"
              :key="index"
            >
              <el-form-item
                class="nameContract"
                :label="item.name + '：'"
                :prop="item.sourceProprety"
                :rules="[
                  {
                    required: item.notNull,
                    message: item.title,
                    trigger: 'blur',
                  },
                  {
                    pattern: new RegExp(item.valueCheckConstraint),
                    message: '格式错误',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  v-if="item.valueDisplayType == 1"
                  v-model="form[item.sourceProprety]"
                  :placeholder="item.title"
                  :maxlength="item.maxlen"
                  size="small"
                ></el-input>
                <el-select
                  v-if="item.valueDisplayType == 2"
                  v-model="form[item.sourceProprety]"
                  :placeholder="item.title"
                  size="small"
                >
                  <el-option
                    :label="items.value"
                    :value="items.id + ''"
                    v-for="(items, indexs) in item.paramsList"
                    :key="indexs"
                  ></el-option>
                </el-select>
                <template v-if="item.valueDisplayType == 3">
                  <el-checkbox-group
                    v-model="form[item.sourceProprety]"
                    size="small"
                  >
                    <el-checkbox
                      v-for="(i, ind) in item.paramsList"
                      :key="ind"
                      :label="item.value"
                    ></el-checkbox>
                  </el-checkbox-group>
                </template>
                <template v-if="item.valueDisplayType == 4">
                  <el-date-picker
                    type="date"
                    :placeholder="item.title"
                    v-model="form[item.sourceProprety]"
                    :clearable="false"
                    value-format="yyyy-MM-dd"
                    size="small"
                  ></el-date-picker>
                </template>
                <template v-if="item.valueDisplayType == 5">
                  <el-select
                    v-model="form[item.sourceProprety]"
                    :placeholder="item.title"
                    size="small"
                  >
                    <el-option
                      :label="items"
                      :value="items"
                      v-for="(items, indexs) in 31"
                      :key="indexs"
                    ></el-option>
                  </el-select>
                </template>
                <el-radio-group
                  v-if="item.valueDisplayType == 6"
                  v-model="form[item.sourceProprety]"
                  :placeholder="item.title"
                  size="small"
                  style="
                    height: 40px;
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                  "
                >
                  <el-radio
                    :label="items.key"
                    :value="items.key + ''"
                    v-for="(items, indexs) in item.paramsList"
                    :key="indexs"
                    >{{ items.value }}</el-radio
                  >
                </el-radio-group>
                <el-input
                  v-if="item.valueDisplayType == 88"
                  v-model="form[item.sourceProprety]"
                  :placeholder="item.title"
                  :maxlength="item.maxlen"
                  size="small"
                  type="textarea"
                  rows="3"
                  resize="none"
                ></el-input>
                <div class="formItemDscp" v-if="item.unit">
                  单位：{{ item.unit }}
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-row>
          <el-col span="8"> </el-col>
        </el-row>
        <div class="item">
          <div class="label">
            <div class="line"></div>
            <div>合同文件</div>
          </div>
          <!-- 非模板发起，需手动上传合同文件 -->
          <div class="fileList" v-if="!isModule">
            <div class="fileItem" v-if="contractList.length">
              <div style="display: flex; flex: 1">
                <div
                  class="openFile"
                  @click="previewFile('', contractList[0], 0)"
                >
                  <img src="../../../assets/images/index/openFile.png" alt="" />
                  <div>点击预览</div>
                </div>
                <div class="fileInfo">
                  <el-input
                    v-if="contractList[0].isEdit"
                    size="mini"
                    style="margin-bottom: 3px"
                    v-model="contractList[0].fileName"
                    @blur="renameConfrim(contractList[0])"
                    maxlength="20"
                  ></el-input>
                  <div class="fileName" v-else>
                    {{ contractList[0].fileName }}
                  </div>
                  <div class="fileSize">{{ contractList[0].fileSizeKB }}</div>
                </div>
              </div>
              <div class="handle" style="flex-shrink: 0">
                <img
                  src="../../../assets/images/index/editIcon.png"
                  alt=""
                  @click="contractList[0].isEdit = true"
                />
                <img
                  @click="deleteContractList"
                  src="../../../assets/images/index/deleteIcon.png"
                  alt=""
                />
              </div>
            </div>
            <upload
              v-if="!contractList.length"
              v-loading="loadingUpload"
              :url="'/file/uploadContract'"
              class="cover"
              :uploadType="'contract'"
              :curCount="1"
              @uploadSuccess="upload"
              @loading="loadingUpload = true"
              @loadingEnd="loadingUpload = false"
              accept=".doc,.docx"
              :fileType="['doc', 'docx']"
              :size="maxSize"
            >
              <div class="fileUpload_box" slot="uploadContent">
                <div class="col1">
                  <img
                    src="../../../assets/images/index/uploadIcon.png"
                    alt=""
                  />
                  <div>选择文件上传</div>
                </div>
                <div class="col2">格式仅限doc、docx，文件尺寸不超过20M</div>
              </div>
            </upload>
          </div>
          <!-- 模板发起，无需手动上传合同文件，系统可自动生成 -->
          <div class="fileList" v-else>
            <div class="fileItem">
              <div style="display: flex; flex: 1">
                <div class="openFile" @click="previewTemplate">
                  <img src="../../../assets/images/index/openFile.png" alt="" />
                  <div>点击预览</div>
                </div>
                <div class="fileInfo">
                  <div class="fileName">
                    {{ templateModuleInfo.name }}
                  </div>
                  <div class="fileSize"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="label">
            <div class="line"></div>
            <div>协议附件</div>
            <div style="color: #bdbdbd; font-size: 14px; margin-left: 4px">
              最多{{ maxCount }}份
            </div>
          </div>
          <div class="fileList">
            <div
              class="fileItem"
              v-for="(item, index) in fileListAnnex"
              :key="item.id"
            >
              <div style="display: flex">
                <div
                  class="openFile"
                  @click="previewFile('annex', item, index)"
                >
                  <img src="../../../assets/images/index/openFile.png" alt="" />
                  <div>点击预览</div>
                </div>
                <div class="fileInfo">
                  <el-input
                    size="mini"
                    style="margin-bottom: 3px"
                    v-if="fileListAnnex[index].isEdit"
                    v-model="fileListAnnex[index].fileName"
                    @blur="renameConfrim(fileListAnnex[index])"
                    maxlength="20"
                  ></el-input>
                  <div class="fileName" v-else>{{ item.fileName }}</div>
                  <div class="fileSize">{{ item.fileSizeKB }}</div>
                </div>
              </div>
              <div class="handle">
                <img
                  src="../../../assets/images/index/editIcon.png"
                  alt=""
                  @click="fileListAnnex[index].isEdit = true"
                />
                <img
                  src="../../../assets/images/index/deleteIcon.png"
                  alt=""
                  @click="fileListAnnex.splice(index, 1)"
                />
              </div>
            </div>
            <uploadAnnex
              v-if="fileListAnnex.length < maxCount"
              :url="'/file/uploadContract'"
              @uploadSuccess="addFileList"
              @loadingEnd="isUploadAnnexLoading = false"
              @loadingStart="isUploadAnnexLoading = true"
              v-loading="isUploadAnnexLoading"
              :fileList="fileListAnnex"
              accept=".pdf,.jpg,.jpeg,.png"
              :fileType="['pdf', 'jpg', 'jpeg', 'png']"
              :size="maxSize"
              @changCurrentIndex="changeFileListFlag"
            >
              <div class="fileUpload_box" slot="uploadContent">
                <div class="col1">
                  <img
                    src="../../../assets/images/index/uploadIcon.png"
                    alt=""
                  />
                  <div>选择文件上传</div>
                </div>
                <div class="col2">
                  格式仅限pdf、jpg、jpeg、png文件尺寸不超过20M
                </div>
              </div>
            </uploadAnnex>
          </div>
        </div>
      </el-form>
    </div>
    <div style="height: 1px"></div>

    <div class="btns" v-if="!isBatchEdit">
      <!-- 原存草稿逻辑 -->
      <!-- <el-button class="saveBtn btn" @click="onSaveDraft">存草稿</el-button>  -->
      <el-button class="saveBtn btn" @click="onBatchDraft">存草稿</el-button>

      <el-button class="submitBtn btn" @click="onFinish()">提交</el-button>

      <el-button class="saveBtn btn absolute-button" @click="onBatchAddFinish"
        >批量导入</el-button
      >
    </div>
    <div class="btns" v-if="isBatchEdit">
      <el-button class="submitBtn btn" @click="onBatchEditFinish()"
        >保存</el-button
      >
    </div>
    <previewFile
      :visible="previewFileVisible"
      :fileArr="fileArr"
      :fileIndexProp="fileIndexProp"
      v-if="previewFileVisible"
      @close="previewFileVisible = false"
    />
    <ImageViewer
      v-if="previewImageVisible"
      :on-close="onPreviewImageClose"
      :initialIndex="initialIndex"
      :urlList="imageUrlList"
    />

    <Loading v-if="$store.state.isLoading"></Loading>
  </div>
</template>

<script>
// import PersonalHead from 'src\components\common\PersonalHead.vue'
import BaseApi from "@lib/baseApi.js";
import PersonalHead from "../../common/PersonalHead.vue";
import Loading from "../../common/Loading.vue";
import fileUpload from "../../components/FileUpload/index.vue";
import Upload from "@common/upload.vue";
import previewFile from "./components/previewFile.vue";
import ImageViewer from "../../common/imageViewer.vue";
import uploadAnnex from "../../common/uploadAnnex.vue";
import { mapGetters, mapState } from "vuex";
import Cascader from "../../components/Cascader/index.vue";
import Reg from "@lib/reg.js";

export default {
  name: "",
  props: {},

  components: {
    PersonalHead,
    Loading,
    fileUpload,
    Upload,
    previewFile,
    uploadAnnex,
    Cascader,
    ImageViewer,
  },

  data() {
    return {
      loadingUpload: false,
      isLoading: false,
      isUploadAnnexLoading: false,

      // 发起数据
      fqData: {},

      form: {
        fqName: "", // 发起方
        fqAgentName: "", // 发起方代理人
        // fqWell: 0, // 签署顺序 1-债权人先签署 2-债务人先签署 3-无顺序

        contractName: "", // 合同名称

        // orderType: "", // 签署顺序 债权人 债务人 无序   1顺序签署  0无序签署

        bgName: "", // 债务人
        bgCardNo: "", // 身份证号码
        bgMobile: "", // 手机号
        bgMail: "", // 邮箱
        bgCitys: [], // 省市区
        bgAddress: "", //  详细地址
      },
      uploadData: {},
      variablList: [],
      zwrVariablList: [], // 债务人模板数据
      zqrVariablList: [], // 债权人模板数据
      contractList: [],
      previewFileVisible: false,
      previewImageVisible: false, // 预览图片
      fileArr: [],
      fileIndexProp: 0,
      fileListAnnex: [],
      imageUrlList: [],
      initialIndex: 0, // 图片预览第几个

      paymentType: "1", //付费方式:1-发起方，2-各签署方

      signContractTipData: [], // 基本信息发起方

      fqTemplateList: [], //赋强合同列表

      contractId: "",

      rules: {
        contractName: {
          required: true,
          message: "请输入合同名称",
          trigger: "blur",
        },
        bgName: {
          required: true,
          message: "请输入姓名",
          trigger: "blur",
        },
        bgCardNo: [
          {
            required: true,
            message: "请输入身份证号码",
            trigger: "blur",
          },
          {
            pattern:
              /^[1-9]\d{5}(?:18|19|20)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/,
            message: "请输入正确的身份证号码",
            trigger: "blur",
          },
        ],
        bgMobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          {
            pattern: Reg.PHONE,
            message: "请输入正确的手机号",
          },
        ],
        bgMail: {
          pattern: Reg.EMAIL,
          message: "请输入正确的邮箱",
        },
      },

      detail: {}, // 详情

      isBatchEdit: false, // 是否是批量过来进行编辑的
      batchEditInfo: {},

      titleName: "填写并发起赋强公证",
      titleNamePrefix: "", // 假面包屑前缀文字
      personalHeadBackPath: "",

      // 上传限制
      maxCount: 5,
      maxSize: 20,

      // 模板发起还是非模板发起
      isModule: false,
      templateModuleInfo: {},

      // 受托列表
      listAssignee: [],
    };
  },

  created() {
    // this.getQueryNotaryBusiness();
    this.uploadContractLimt();
    this.getFqContractTemplate();
    this.getCurrentSign();
  },
  mounted() {},
  computed: {
    ...mapState(["currentInfo"]),
    ...mapGetters(["getCurInfo", "getUserInfo"]),
    isLoading() {
      return this.$store.state.isLoading;
    },
  },
  methods: {
    onFinish(draft) {
      // 提交
      console.log(this.form, "form");
      console.log(this.$refs.form, "this.$refs.form");
      console.log(this.signContractTipData, "signContractTipData");
      console.log(this.contractList, "contractList");
      console.log(this.fileListAnnex, "fileListAnnex");
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (!this.contractList.length && !this.isModule) {
            // 非模板发起需要手动上传合同文件
            this.$message.error("请上传合同文件");
            return;
          }
          // 提交时做一次 precision 配置的校验  一般为金额小数点前后位的长度限制
          for (let i = 0; i < this.fqTemplateList[0].variablList.length; i++) {
            let info = this.fqTemplateList[0].variablList[i];
            if (info.precision) {
              console.log(info, "info");
              let precisionArr = info.precision.split(",");
              let vs = (this.form[info.sourceProprety] + "").split(".");
              console.log(precisionArr, "precisionArr");
              console.log(vs, "vs");

              if (vs[0] && vs[0].length > precisionArr[0]) {
                this.$message.error(
                  info.name + "整数位最大" + precisionArr[0] + "位"
                );
                return;
              }
              if (vs[1] && vs[1].length > precisionArr[1]) {
                this.$message.error(
                  info.name + "小数位最大" + precisionArr[1] + "位"
                );
                return;
              }
            }
          }

          if (this.signContractTipData.length <= 1) {
            this.$message.error("缺少债务人信息");
            return;
          }

          this.$store.commit("showLoading", true);
          const inforMationData = this.initInforMationDataData();
          console.log(inforMationData, "inforMationDatainforMationData");
          await this.initUpdate();
          BaseApi.createRpcToken(
            "/fqContract/generateFileByTemplateAndUploadContract",
            inforMationData,
            "get"
          ).then(
            async (res) => {
              if (res.code == 200 && res.datas.fileInfo.id) {
                let addParams = this.initAddData().params;
                addParams = {
                  ...addParams,
                  fileIds: [res.datas.fileInfo.id]
                    .concat(addParams.fileIds)
                    .join(","),
                };
                if (this.contractId) {
                  addParams.id = this.contractId;
                }
                console.log(addParams, "addParams");
                BaseApi.createRpcToken("/contract/add", addParams, "post").then(
                  (data) => {
                    this.$store.commit("showLoading", false);
                    if (data.datas == null && this.paymentType == "2") {
                      this.$message.error(
                        "添加的签署方存在未注册用户，请添加已注册的签署方！"
                      );
                      return;
                    }
                    this.contractId = data.datas.id;

                    if (draft) {
                      // 存草稿
                      this.$message.success("成功保存至草稿");
                      this.$router.push("/personal/sign/home");
                      return;
                    }

                    // 无需付费
                    if (this.getUserInfo.signWhetherPayment === 2) {
                      this.$router.push({
                        path: `/personal/sign/complete?id=${this.contractId}&flag=startSign&type=2`,
                      });
                      return;
                    }

                    let that = this;
                    //发起方付费
                    if (that.paymentType == 1) {
                      // 判断是否已经支付过
                      that.$store.commit("showLoading", true);
                      that.getContractInfo().then(
                        async function (res) {
                          console.log(res, "resresresresres");
                          that.$store.commit("showLoading", false);
                          if (res.datas.info.payStatus == 0) {
                            //去支付
                            this.$message.success("提交成功");
                            that.$router.push({
                              path: "/personal/payment",
                              query: {
                                id: that.contractId,
                                flag: "startSign",
                                type: 2,
                              },
                            });
                          } else {
                            that.$router.push({
                              path: `/personal/sign/complete?id=${that.contractId}&flag=startSign&type=2`,
                            });
                          }
                        },
                        () => {
                          that.$store.commit("showLoading", false);
                        }
                      );
                    }
                  },
                  () => {
                    this.$store.commit("showLoading", false);
                  }
                );
              }
            },
            () => {
              this.$store.commit("showLoading", false);
            }
          );
        }
      });
    },

    // 删除合同文件
    deleteContractList() {
      this.contractList = [];
    },

    // 批量列表，编辑保存
    async onBatchEditFinish(add) {
      this.$store.commit("showLoading", true);
      let t_res = null;
      if (this.isModule || (!this.isModule && this.contractList.length) ) {
        t_res = await this.updategenerateFileByTemplateAndUploadContract();
      }
      if (t_res && t_res.code !== 200) {
        this.$store.commit("showLoading", false);
        this.$message.error(t_res.message || t_res.msg);
        return;
      }
      const info = this.getBatchInfo();
      if (t_res && t_res.datas && t_res.datas.fileInfo.id) {
        info.bizData.contractFileId = t_res.datas.fileInfo.id;
      }
      info.bizData = JSON.stringify(info.bizData);
      BaseApi.createRpcToken("/import/updateImportDetail", info, "post").then(
        async (res) => {
          this.$store.commit("showLoading", false);
          if (res.code == 200) {
            // 保存成功
            this.$router.push("/initiation/batch");
          }
        },
        () => {
          this.$store.commit("showLoading", false);
        }
      );
    },
    // 单个转批量
    onBatchAddFinish() {
      this.$confirm("进入批量申请后，是否保留当前业务?", "提示", {
        confirmButtonText: "保存",
        cancelButtonText: "放弃",
        type: "warning",
        closeOnPressEscape: false,
        closeOnClickModal: false,
        distinguishCancelAndClose: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            done();
            this.onBatchAddFinishHandelr();
          } else if (action === "cancel") {
            done();
            this.$router.push("/initiation/batch");
          } else {
            done();
          }
        },
      });
    },
    // 存草稿
    onBatchDraft() {
      this.onBatchAddFinishHandelr();
    },
    // 执行存草稿逻辑
    async onBatchAddFinishHandelr() {
      this.$store.commit("showLoading", true);
      let t_res = null;
      if (this.isModule || (!this.isModule && this.contractList.length) ) {
        t_res = await this.updategenerateFileByTemplateAndUploadContract();
      }
      if (t_res && t_res.code !== 200) {
        this.$store.commit("showLoading", false);
        this.$message.error(t_res.message || t_res.msg);
        return;
      }
      const info = this.getBatchInfo();
      if (t_res && t_res.datas && t_res.datas.fileInfo && t_res.datas.fileInfo.id) {
        info.bizData.contractFileId = t_res.datas.fileInfo.id;
      }
      info.bizData = JSON.stringify(info.bizData);
      BaseApi.createRpcToken("/import/addContractDetail", info, "post").then(
        async (res) => {
          this.$store.commit("showLoading", false);
          if (res.code == 200) {
            // 保存成功
            this.$router.push("/initiation/batch");
          }
        },
        () => {
          this.$store.commit("showLoading", false);
        }
      );
    },
    // 更新合同信息 返回id 存至 contractFileId
    async updategenerateFileByTemplateAndUploadContract() {
      const inforMationData = this.initInforMationDataData();
      return BaseApi.createRpcToken(
        "/fqContract/generateFileByTemplateAndUploadContract",
        inforMationData,
        "get"
      );
    },

    // 获取批量编辑所需数据信息
    getBatchInfo() {
      let inforMation = {};
      this.variablList.forEach((item) => {
        Object.keys(this.form).forEach((key) => {
          if (item.sourceProprety === key) {
            inforMation[key] = this.form[key];
          }
        });
      });
      this.zwrVariablList.forEach((item) => {
        Object.keys(this.form).forEach((key) => {
          if (item.sourceProprety === key) {
            inforMation[key] = this.form[key];
          }
        });
      });
      this.zqrVariablList.forEach((item) => {
        Object.keys(this.form).forEach((key) => {
          if (item.sourceProprety === key) {
            inforMation[key] = this.form[key];
          }
        });
      });
      let annexFileData = {};
      this.fileListAnnex.forEach((item, index) => {
        annexFileData["attachfileId" + (index + 1)] = item.id;
        annexFileData["attachfile" + (index + 1)] = item.fileName;
      });
      let inforMationData = {
        ...inforMation,
        contractName: inforMation.contractName,
        ...annexFileData,
      };

      if (
        this.contractList.length &&
        this.contractList[0] &&
        this.contractList[0].id
      ) {
        // 非模板发起才需要合同文件  如编辑传入合同，需回传
        inforMationData.contractFileId = this.contractList[0].id;
      }

      if (inforMationData.documentNum) {
        // 乙方身份证号码 将小写x替换为大写X
        inforMationData.documentNum = inforMationData.documentNum.replace(
          /x/g,
          "X"
        );
      }
      let info = {
        bizData: inforMationData,
        contractName: inforMationData.contractName, // 合同名称
        userBizNumber: inforMationData.contractNo, // 用户提供的合同编号
        debtorName: inforMationData.borrower, // 债务人姓名
        debtorCardNo: inforMationData.documentNum, // 债务人身份证号码
        debtorPhone: inforMationData.contactNum, // 债务人手机号
        comment: inforMationData.contractComment, // 合同备注信息
        repayAmount: inforMationData.repayAmount, // 还款金额
      };
      if (this.batchEditInfo.id) {
        info.id = this.batchEditInfo.id;
      }

      return info;
    },

    // 保存草稿
    onSaveDraft() {
      this.onFinish("draft");
    },

    getEditInfo() {
      BaseApi.createRpcToken("/contract/find", {
        id: this.$route.query.id,
      }).then(
        (data) => {
          this.contractId = this.$route.query.id;
          let detail = data.datas.contract;
          let signatoryList = detail.signatoryList;
          let fqInfo = signatoryList[0];
          let bgInfo = signatoryList[1];

          if (fqInfo) {
            this.form.fqName = fqInfo.name;
            this.form.fqName = fqInfo.name;
          }
          if (bgInfo) {
            this.form.borrower = bgInfo.name;
            this.form.contactNum = bgInfo.mobile;
            this.form.contactMailbox = bgInfo.mail;
            this.form.documentNum = bgInfo.cardNo;
            if (bgInfo.contactAddress) {
              let contactAddress = JSON.parse(bgInfo.contactAddress);
              this.form.postalAddress = contactAddress.address;
              // this.form.bgCitys = [
              //   contactAddress.province,
              //   contactAddress.city,
              //   contactAddress.area,
              // ];
            }
          }

          if (detail.info) {
            this.form.contractName = detail.info.name;

            if (detail.info.orderType === 1) {
              // 有序签署 0-债权人先签署 1-债务人先签署 2-无顺序
              if (signatoryList[0].type === 2) {
                // 企业先签署，则认为 债权人先签署
                this.form.signOrder = 1;
              } else {
                this.form.signOrder = 2;
              }
            } else {
            }
          }

          // 设置签署方信息
          let tempArr = [];
          signatoryList.forEach((value, index) => {
            let temp = {
              userName: value.name,
              realNameType: value.type,
              type: value.type,
              realNameStatus: value.realNameStatus == 0 ? 2 : 1,
              account: value.mobile || value.mail,
              signatoryId: value.id,
              signOrderNum: value.signOrderNumm,
              index: index + 1,
              offlineSign: process.env.VUE_APP_OFFLINESIGN_FLAG ? false : "",
            };
            tempArr.push(temp);
          });
          this.signContractTipData = tempArr;

          this.contractList = detail.fileList;
          this.fileListAnnex = detail.attachmentList;

          // 设置模板信息
          if (
            this.fqTemplateList &&
            this.fqTemplateList.length &&
            data.datas.fileVariableInfo
          ) {
            const fqTemplate = this.fqTemplateList[0];
            const fileVariableInfoParams = data.datas.fileVariableInfo.filter(
              (item) => item.templateId === fqTemplate.templateId
            )[0];
            if (fileVariableInfoParams && fileVariableInfoParams.params) {
              const params = JSON.parse(fileVariableInfoParams.params);
              console.log(params, "params");
              if (Object.values(params).length) {
                this.variablList.forEach((item) => {
                  if (item.valueDisplayType !== 4) {
                    if (item.valueDisplayType === 6) {
                      // 设置form参数值
                      this.$set(
                        this.form,
                        item.sourceProprety,
                        typeof params[item.sourceProprety] === "number"
                          ? Number(params[item.sourceProprety])
                          : Number(params[item.sourceProprety][0])
                      );
                    } else {
                      // 设置form参数值
                      this.$set(
                        this.form,
                        item.sourceProprety,
                        typeof params[item.sourceProprety] === "string"
                          ? params[item.sourceProprety]
                          : params[item.sourceProprety][0]
                      );
                    }
                  } else {
                    this.$set(
                      this.form,
                      item.sourceProprety,
                      new Date(
                        params[item.sourceProprety][0].replace(/-/g, "/")
                      )
                    );
                  }
                });
              }
            }
          }

          // if (this.variablList && this.variablList.length) {
          //     this.variablList.forEach((item) => {
          //       // 设置form参数值
          //       this.$set(
          //         this.form,
          //         item.sourceProprety,
          //         item.valueDisplayType == 3 ? [] : ""
          //       );
          //       //设置校验条件
          //       // this.$set(this.rules, item.sourceProprety, );
          //     });
          //     console.log(this.rules, "rules");
          //   }

          // try {

          // } catch (e) {
          //   console.log(123)
          // }
        },
        (err) => {}
      );
    },

    getContractInfo() {
      return BaseApi.createRpcToken(
        "/contract/info",
        { id: this.contractId },
        "post"
      );
    },

    // 处理结果 将结果update
    initUpdate() {
      this.$store.commit("showLoading", true);
      let paramsUpdate = this.initAddData().paramsUpdate;
      console.log(this.initAddData(), "initAddData");
      return BaseApi.createRpcToken(
        "/signatory/updateSignatory",
        paramsUpdate,
        "post"
      );
    },

    // 处理结果 将最后的结果出来为可用数据
    initAddData() {
      // /contract/add 接口所需参数
      let date = this.initSizeDate();
      let params = {
        name: this.form.contractName,
        validityDateType: 1, // 手动选择起止时间
        ...date,
        type: 2,
        orderType: "", // 1顺序签署  0无序签署

        offlineFlagMap: "", // 线下签署
        payMode: this.paymentType, // 付费方式 发起方还是签署方
      };
      let signContractTipData = []; // 签署列表，需处理
      signContractTipData.push(this.signContractTipData[0]);
      signContractTipData.push(
        this.signContractTipData[this.signContractTipData.length - 1]
      );

      let signContractTipData2 = []; // 处理债权人先还是债务人先
      // fqWell: 0, // 签署顺序 1-债权人先签署 2-债务人先签署 3-无顺序
      if (this.form.signOrder == 3) {
        // 无序
        params.orderType = 0;
        signContractTipData2 = signContractTipData;
      } else {
        // 有序
        params.orderType = 1;
        if (this.form.signOrder == 2) {
          // 债务人先签署
          signContractTipData2.push(signContractTipData[1]); // 第二个为债务人
          signContractTipData2.push(signContractTipData[0]);
        } else {
          signContractTipData2 = signContractTipData;
        }
      }

      let listTemp = [];
      signContractTipData2.forEach(function (value) {
        listTemp.push(value.signatoryId);
      });

      params.signatoryIds = listTemp.join(",");
      if (this.getUserInfo.signWhetherPayment === 2) {
        // 无需付费
        params.signWhetherPayment = this.getUserInfo.signWhetherPayment;
      }

      let fileIds = [];
      this.fileListAnnex.forEach((item) => {
        fileIds.push(item.id);
      });
      params.fileIds = fileIds;

      let paramsUpdate = {
        id: signContractTipData[1].signatoryId,
        name: this.form.borrower,
        cardNo: this.form.documentNum,
        mobile: this.form.contactNum,
        mail: this.form.contactMailbox,
        contactAddress: {},
      };
      // if (this.form.bgCitys) {
      //   paramsUpdate.contactAddress.province = this.form.bgCitys[0];
      //   paramsUpdate.contactAddress.city = this.form.bgCitys[1];
      //   paramsUpdate.contactAddress.area = this.form.bgCitys[2];
      // }
      if (this.form.postalAddress) {
        paramsUpdate.contactAddress.address = this.form.postalAddress;
      }
      if (paramsUpdate.contactAddress) {
        paramsUpdate.contactAddress = JSON.stringify(
          paramsUpdate.contactAddress
        );
      }

      // 债权人委托方
      if (this.form.creditAssignee) {
        params.creditAssignee = this.form.creditAssignee;
      }

      return {
        params: params,
        paramsUpdate: paramsUpdate,
      };
    },
    // 获取合同有效期和签约截止日期
    initSizeDate() {
      let ts = new Date().getTime(); // 当天
      let ts1 = ts + 5 * 365 * 24 * 60 * 60 * 1000; // 1年后
      let ts2 = ts + 30 * 24 * 60 * 60 * 1000; // 30天后

      return {
        startDate: this.getNowFormatDate(ts), // 合同有效期开始日期
        dateRange: this.getNowFormatDate(ts), // 合同有效期
        endDate: this.getNowFormatDate(ts1), // 合同有效期截止日期
        signDeadlineDate: this.getNowFormatDate(ts2), // 签约截止日期
      };
    },
    getNowFormatDate(time) {
      let date = new Date(time),
        year = date.getFullYear(), //获取完整的年份(4位)
        month = date.getMonth() + 1, //获取当前月份(0-11,0代表1月)
        strDate = date.getDate(); // 获取当前日(1-31)
      if (month < 10) month = `0${month}`; // 如果月份是个位数，在前面补0
      if (strDate < 10) strDate = `0${strDate}`; // 如果日是个位数，在前面补0
      return `${year}-${month}-${strDate}`;
    },

    // 处理结果 将最后的结果出来为可用数据
    initInforMationDataData() {
      // generateFileByTemplateAndUploadContract 接口所需参数
      let inforMation = {};
      this.variablList.forEach((item) => {
        Object.keys(this.form).forEach((key) => {
          if (item.sourceProprety === key) {
            inforMation[key] = this.form[key];
          }
        });
      });
      this.zwrVariablList.forEach((item) => {
        Object.keys(this.form).forEach((key) => {
          if (item.sourceProprety === key) {
            inforMation[key] = this.form[key];
          }
        });
      });
      this.zqrVariablList.forEach((item) => {
        Object.keys(this.form).forEach((key) => {
          if (item.sourceProprety === key) {
            inforMation[key] = this.form[key];
          }
        });
      });
      let inforMationData = {
        ...inforMation,
        templateId: this.fqTemplateList[0].filePath
          ? this.fqTemplateList[0].templateId
          : undefined,
      };
      if (
        this.contractList.length &&
        this.contractList[0].id &&
        !this.isModule
      ) {
        inforMationData.fileId = this.contractList[0].id;
      }

      console.log(inforMationData, "inforMationData");
      if (inforMationData.documentNum) {
        // 乙方身份证号码 将小写x替换为大写X
        inforMationData.documentNum = inforMationData.documentNum.replace(
          /x/g,
          "X"
        );
      }

      return inforMationData;
    },

    changeFileListFlag(current) {
      this.fileListAnnex[current.index].currentIndex = current.value;
    },
    addFileList(res) {
      res.datas.fileInfo.currentIndex = 1;
      this.fileListAnnex.push({ ...res.datas.fileInfo, isEdit: false });
    },
    upload(item) {
      this.contractList.push({ ...item.datas.fileInfo, isEdit: false });
    },
    uploadHeader() {
      return {
        token: localStorage.getItem("token"),
        "X-CSRF-Token": sessionStorage.token,
      };
    },
    //查询赋强合同模板列表
    getFqContractTemplate() {
      this.$store.commit("showLoading", true);
      BaseApi.createRpcToken("/fqContract/getFqContractTemplate").then(
        async (data) => {
          if (data.code == 200) {
            this.$store.commit("showLoading", false);
            this.fqTemplateList = data.datas.fqTemplateList;
            let zwr = []; // 债务人
            let zqr = []; // 债权人
            let variablList = []; // 额外参数
            if (data.datas.fqTemplateList && data.datas.fqTemplateList.length) {
              let list = data.datas.fqTemplateList[0].variablList;
              list.forEach((item) => {
                // 判断是否使用textarea
                if (item.sourceProprety === "postalAddress") {
                  // 债务人.实际联系地址
                  // item.valueDisplayType = 88;
                  item.span = 16;
                }
                if (item.sourceProprety === "contractComment") {
                  // 合同备注
                  item.valueDisplayType = 88;
                  item.span = 24;
                }

                if (item.name.indexOf("债务人.") >= 0) {
                  item.nameValue = item.name.split("债务人.")[1];
                  zwr.push(item);
                } else if (item.name.indexOf("债权人.") >= 0) {
                  item.nameValue = item.name.split("债权人.")[1];
                  zqr.push(item);
                } else {
                  variablList.push(item);
                }

                // 设置form参数值
                this.$set(
                  this.form,
                  item.sourceProprety,
                  item.valueDisplayType == 3 ? [] : ""
                );
                // 默认债权人先签署
                if (item.sourceProprety === "signOrder") {
                  this.$set(this.form, item.sourceProprety, 1);
                }
                //设置校验条件
                // this.$set(this.rules, item.sourceProprety, );
              });

              // 是否是模板发起判断
              if (data.datas.fqTemplateList[0]) {
                if (data.datas.fqTemplateList[0].filePath) {
                  this.isModule = true;
                  this.templateModuleInfo = data.datas.fqTemplateList[0];
                }
              }
            }
            this.variablList = variablList;
            this.zwrVariablList = zwr;
            this.zqrVariablList = zqr;

            if (
              this.zqrVariablList.filter(
                (item) => item.sourceProprety === "creditAssignee"
              ).length
            ) {
              await this.getListAssignee();
            }

            if (this.$route.query.id) {
              this.getEditInfo();
            } else if (
              this.$route.query.batchEdit &&
              sessionStorage.getItem("batchEdit")
            ) {
              this.titleName = "业务编辑";
              this.titleNamePrefix = "待发起业务列表 > ";
              this.getBatchEdit();
            }
          }
        },
        (err) => {}
      );
    },

    async getBatchEdit() {
      let batchEdit = sessionStorage.getItem("batchEdit");
      if (batchEdit) {
        this.personalHeadBackPath = "/initiation/batch";
        batchEdit = JSON.parse(batchEdit);
        this.isBatchEdit = true;
        this.batchEditInfo = batchEdit;

        let bizData = batchEdit.bizData;
        // 设置债务人信息
        Object.keys(bizData).forEach((key) => {
          this.zwrVariablList.forEach((item) => {
            if (item.sourceProprety === key) {
              // 设置form参数值
              this.$set(this.form, item.sourceProprety, bizData[key]);
            }
          });
        });
        // 设置债权人信息
        Object.keys(bizData).forEach((key) => {
          this.zqrVariablList.forEach((item) => {
            if (item.sourceProprety === key) {
              // 设置form参数值
              this.$set(this.form, item.sourceProprety, bizData[key]);
            }
          });
        });
        // 设置合同信息
        Object.keys(bizData).forEach((key) => {
          this.variablList.forEach((item) => {
            if (item.sourceProprety === key) {
              // 设置form参数值
              this.$set(this.form, item.sourceProprety, bizData[key]);
            }
          });
        });
        // 设置合同文件
        if (bizData.contractFileId) {
          // 获取合同文件信息
          const file = await this.getContractFile(bizData.contractFileId);
          this.contractList = [{ ...file, isEdit: false }];
        }
        // 设置附件信息
        Object.keys(bizData).forEach(async (key) => {
          if (key.indexOf("attachfileId") >= 0) {
            // 获取附件信息，并插入附件列表
            const file = await this.getContractFile(bizData[key]);
            this.fileListAnnex.push({ ...file, isEdit: false });
          }
        });
      }
    },
    // 读取合同文件信息
    async getContractFile(fileId) {
      return new Promise((reslove) => {
        BaseApi.createRpcToken("/file/getContractFile", {
          fileId,
        }).then(
          (data) => {
            if (data.datas && data.datas.fileInfo && data.datas.ossUrl) {
              reslove({
                ...data.datas.fileInfo,
                filePath: data.datas.ossUrl,
              });
            }
          },
          (data) => {}
        );
      });
    },
    // 修改文件名
    renameConfrim(item) {
      if (!item.fileName) {
        this.$message.error("请输入合同名称");
        return;
      }
      BaseApi.createRpcToken(
        "/file/rename",
        {
          id: item.id,
          fileName: item.fileName,
        },
        "post"
      )
        .then(
          (data) => {
            this.$message.success("重命名成功");
            item.isEdit = false;
          },
          () => {}
        )
        .catch(function (e) {
          errorLog(e);
        });
    },

    // 模板发起预览
    previewTemplate() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (!this.isBatchEdit) {
            // 不是批量编辑
            if (this.signContractTipData.length <= 1) {
              this.$message.error("缺少债务人信息");
              return;
            }
          }

          this.$store.commit("showLoading", true);
          const inforMationData = this.initInforMationDataData();
          BaseApi.createRpcToken(
            "/fqContract/generateFileByTemplateAndUploadContract",
            inforMationData,
            "get"
          ).then(
            async (res) => {
              this.$store.commit("showLoading", false);
              if (res.code == 200 && res.datas.fileInfo.id) {
                this.fileArr = [res.datas.fileInfo];
                this.fileIndexProp = 0;
                this.previewFileVisible = true;
              }
            },
            () => {
              this.$store.commit("showLoading", false);
            }
          );
        }
      });
    },

    previewFile(type, fileInfo, index) {
      let fileArr = [];
      if (!type) {
        fileArr = this.contractList;
      } else {
        fileArr = this.fileListAnnex;
      }
      let pdfs = [];
      let imgs = [];
      fileArr.forEach((item) => {
        if (fileInfo.fileFormat.indexOf("pdf") >= 0) {
          pdfs.push(item);
        } else {
          imgs.push(item);
        }
      });

      if (fileInfo.fileFormat.indexOf("pdf") >= 0) {
        let fileIndexProp = 0;
        pdfs.forEach((item, index) => {
          if (item.id === fileInfo.id) {
            fileIndexProp = index;
          }
        });
        // 预览pdf
        this.fileArr = pdfs;
        this.fileIndexProp = fileIndexProp;
        this.previewFileVisible = true;
      } else {
        let initialIndex = 0;
        imgs.forEach((item, index) => {
          if (item.id === fileInfo.id) {
            initialIndex = index;
          }
        });
        // 预览图片
        this.imageUrlList = imgs.map((item) => item.filePath);
        this.initialIndex = initialIndex;
        this.previewImageVisible = true;
      }
      // if (this.fileArr.length) {
      //   let fileFormat = this.fileArr[0].fileFormat;
      //   if (fileFormat.indexOf('pdf') >= 0) {
      //     this.previewFileVisible = true;
      //   } else {
      //     console.log(fileFormat, 'fileFormat');
      //     this.imageUrlList = [this.fileArr[0].filePath];
      //     this.previewImageVisible = true;
      //   }
      // }
    },

    getCurrentSign() {
      let newCur;
      let type;
      //当前显示的
      if (this.getUserInfo.hasOwnProperty("currentUserId")) {
        newCur = [
          ...[this.getUserInfo.person],
          ...this.getUserInfo.enterpriseList,
        ];
        type = newCur.filter(
          (item) => item.userId == this.getUserInfo.currentUserId
        )[0];

        console.log(type, "type");

        if (type.realNameType == 1) {
          // 自然人 不支持
          this.$message.error("暂不支持自然人发起赋强公证");
          history.go(-1);
        } else {
          this.fqData = {
            ...type,
            person: this.getUserInfo.person,
          };

          // 设置代理人
          this.form.fqAgentName = this.getUserInfo.person.realName;
          if (!this.$route.query.id) {
            this.newSaveEn(type);
          }
        }
      }
    },

    //默认企业签署
    newSaveEn(datasCur) {
      console.log(datasCur, "datasCurdatasCur");
      console.log(
        this.signContractTipData,
        "signContractTipDatasignContractTipData"
      );
      let Arrindex = this.signContractTipData.filter(
        (item, index) => item.userName == datasCur.realName
      )[0];
      let index = this.signContractTipData.indexOf(Arrindex);
      this.signContractTipData.splice(Arrindex, 1);
      BaseApi.createRpcToken("/signatory/v2/addEnterpriseSignatory", {
        name: datasCur.realName,
      }).then(
        (data) => {
          this.addIndex(this.signContractTipData);
          if (data.datas.code == 3001) {
            // 用户已经存在 则直接使用
            if (this.judgeUid(data.datas.signatoryId)) {
              this.signContractTipData.push({
                signatoryId: data.datas.signatoryId,
                type: "2",
                account: "",
                amount: "",
                userName: datasCur.realName,
                realNameStatus: "1",
                offlineSign: false,
              });
              console.log(this.signContractTipData, "signContractTipData");
              // this.signMShow = false;
              // this.searchEnname = "";

              // 企业签署 设置form值
              const info = this.signContractTipData[0];
              this.form.fqName = info.userName;
            }
          } else {
            if (this.judgeUid(data.datas.signatoryId)) {
              this.signContractTipData.push({
                signatoryId: data.datas.signatoryId,
                type: "2",
                amount: "",
                account: data.datas.mobile || data.datas.mail,
                userName: datasCur.realName,
                realNameStatus: "1",
              });
              this.addIndex(this.signContractTipData);
              console.log(this.signContractTipData, "signContractTipData2");
              // this.signMShow = false;
              // this.searchEnname = "";

              // 企业签署 设置form值
              const info = this.signContractTipData[0];
              this.form.fqName = info.userName;
            }
          }
        },
        (data) => {}
      );
    },

    addIndex(data) {
      if (data && data.length) {
        data.forEach((value, index) => {
          value.index = index + 1;
        });
      }
    },

    judgeUid(signatoryId) {
      for (let i = 0; i < this.signContractTipData.length; i++) {
        if (this.signContractTipData[i].signatoryId == signatoryId) {
          return false;
        }
      }
      return true;
    },

    // 获取默认签署顺序
    getQueryNotaryBusiness() {
      BaseApi.createRpcToken("/notaryApply/queryNotaryBusiness", {
        notaryBusinessCode: "FQGZ",
      }).then(
        (data) => {
          if (data.datas && data.datas.serviceConfig) {
            let serviceConfig = JSON.parse(data.datas.serviceConfig);
            this.form.signOrder = Number(serviceConfig.signOrder) || 1;
          }
        },
        (data) => {}
      );
    },

    savePerson(flag, data) {
      let queryParams = {
        mail: "",
        mobile: "",
        handleType: "1",
        partnerId: "13",
      };
      if (flag == "addNormal") {
        if (this.signContractTipData.length == 0 && !this.addFlag) {
          this.addFlag = true;
          queryParams.mobile = data.mobile;
          queryParams.mail = data.mail;
          this.addSign(queryParams);
        }
      } else {
        if (this.form.contactNum) {
          if (Reg.PHONE.test(this.form.contactNum)) {
            queryParams.mobile = this.form.contactNum;
          } else {
            // this.$message.error("手机号格式错误");
            return;
          }
          this.addSign(queryParams);
        }
      }
    },
    addSign(queryParams) {
      if (this.judgeCanAdd(queryParams.mobile || queryParams.mail)) {
        this.powerId && (queryParams.userId = this.powerId);
        BaseApi.createRpcToken("/signatory/queryUserName", queryParams)
          .then(
            (data) => {
              if (data.datas.resultList) {
                let resultList = data.datas.resultList;
                console.log(resultList, "resultList");
                if (process.env.VUE_APP_OFFLINESIGN_FLAG) {
                  resultList[0].offlineSign = false;
                }

                if (resultList[0].id) {
                  if (this.judgeUid(resultList[0].id)) {
                    resultList[0].signatoryId = resultList[0].id;
                    resultList[0].account =
                      queryParams.mobile || queryParams.mail;
                    resultList[0].userName = resultList[0].name;
                    resultList[0].amount = "";
                    this.signContractTipData.push(resultList[0]);
                    this.addIndex(this.signContractTipData);
                    console.log("债务人信息，");

                    // 查询完毕后 填入债务人信息
                    // this.form.borrower = resultList[0].name || "";
                    // this.form.contactMailbox = resultList[0].mail || "";
                    // this.form.documentNum = resultList[0].cardNo || "";
                    // if (resultList[0].contactAddress) {
                    //   let contactAddress = JSON.parse(
                    //     resultList[0].contactAddress
                    //   );
                    //   // 省市区暂不填入
                    //   // if (contactAddress.province) {
                    //   //   this.form.bgCitys = [
                    //   //     contactAddress["province"],
                    //   //     contactAddress["city"],
                    //   //     contactAddress["area"],
                    //   //   ];
                    //   // }
                    //   if (contactAddress.address) {
                    //     this.form.postalAddress = contactAddress.address;
                    //   }
                    // }
                  } else {
                    this.$message.error("不能添加相同的签署方");
                    this.form.contactNum = ""; // 手机号置空
                  }
                } else {
                  resultList[0].name && (queryParams.name = resultList[0].name);
                  resultList[0].type && (queryParams.type = resultList[0].type);
                  resultList[0].signUserId &&
                    (queryParams.signUserId = resultList[0].signUserId);
                  this.powerId && (queryParams.userId = this.powerId);
                  BaseApi.createRpcToken(
                    "/signatory/addSignatory",
                    queryParams,
                    "post"
                  )
                    .then(
                      (data) => {
                        if (this.judgeUid(data.datas.signatoryId)) {
                          data.datas.account =
                            queryParams.mobile || queryParams.mail;
                          data.datas.realNameStatus =
                            resultList[0].realNameStatus;
                          data.datas.amount = "";
                          data.datas.userName = resultList[0].name;
                          data.datas.type = resultList[0].type;
                          this.signContractTipData.push(data.datas);
                          this.addIndex(this.signContractTipData);

                          // 设置form
                          this.form.borrower = data.datas.name || "";
                          this.form.contactMailbox = data.datas.mail || "";
                        } else {
                          this.$message.error("不能添加相同的签署方");
                        }
                      },
                      () => {}
                    )
                    .catch(function (e) {
                      errorLog(e);
                    });
                }
              } else {
              }
            },
            (error) => {}
          )
          .catch(function (e) {
            errorLog(e);
          });
      } else {
        // this.$message.error("不能添加相同的签署方");
      }
    },
    judgeCanAdd(flag) {
      for (let i = 0; i < this.signContractTipData.length; i++) {
        if (this.signContractTipData[i].account == flag) {
          return false;
        }
      }
      return true;
    },

    // 债务人输入框blur事件
    zwrStoreData(sourceProprety) {
      if (sourceProprety === "contactNum") {
        this.savePerson("", {
          contactNum: this.form["contactNum"],
        });
      }
    },

    // 关闭图片预览
    onPreviewImageClose() {
      this.previewImageVisible = false;
    },

    // 查询上传限制
    uploadContractLimt() {
      BaseApi.createRpcToken("/file/uploadContractLimt", "", "post").then(
        (data) => {
          if (data && data.datas) {
            console.log(data, "data");
            this.maxCount = data.datas.maxCount;
            this.maxSize = data.datas.maxSize;
          }
        }
      );
    },

    //  受托列表 /user/listAssignee
    async getListAssignee() {
      await BaseApi.createRpcToken("/user/listAssignee", "", "post").then(
        (data) => {
          if (data && data.datas) {
            this.listAssignee = data.datas.list;
            // 筛选债权人委托方
            let arr = this.zqrVariablList.filter(
              (item) => item.sourceProprety === "creditAssignee"
            );
            if (arr && arr.length) {
              let paramsList = data.datas.list.map((item) => {
                return {
                  id: item,
                  value: item,
                };
              });
              arr[0].paramsList = paramsList;
              this.form.creditAssignee = paramsList[0].id;
            }
          }
        }
      );
    },
  },
};
</script>

<style scoped lang="scss">
.single_container {
  background-color: #eaedf1;
  width: 100%;
  min-height: 100vh;
  padding-top: 60px;
  .personalMainHead {
    width: 100%;
    height: 60px;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 100;
  }
  .info_box {
    width: 1350px;
    min-height: 663px;
    overflow: auto;
    background-color: #fff;
    margin: 5px auto 80px;
    padding: 32px 56px;
    box-sizing: border-box;
    .task_form {
      width: 100%;
    }
    .item {
      margin-bottom: 12px;
      .label {
        display: flex;
        align-items: center;
        margin-bottom: 23px;
        .line {
          width: 4px;
          height: 20px;
          background: #d81212;
          border-radius: 4px;
          margin-right: 10px;
        }
      }
      .fileUpload_box {
        width: 372px;
        height: 68px;
        background: rgba(219, 28, 27, 0.08);
        border-radius: 2px;
        line-height: normal;
        border: 1px dashed #db1c1b;
        cursor: pointer;
        .col1 {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 15px;
          color: #db1c1b;
          img {
            width: 16px;
            height: 16px;
            margin-right: 4px;
          }
        }
        .col2 {
          margin-top: 8px;
          font-size: 12px;
          text-align: center;
          color: #bdbdbd;
        }
      }
      .fileList {
        padding-left: 40px;
        display: flex;
        width: 100%;
        flex-wrap: wrap;
        box-sizing: border-box;
        .fileItem {
          width: 356px;
          margin-right: 59px;
          margin-bottom: 12px;
        }
      }
      .fileItem {
        border: 1px dashed #e9e9e9;
        height: 54px;
        padding: 6px 8px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        line-height: normal;
        .openFile {
          width: 48px;
          display: flex;
          flex-direction: column;
          align-items: center;
          font-size: 12px;
          color: #bdbdbd;
          cursor: pointer;
          margin-right: 12px;
          img {
            width: 24px;
            margin-bottom: 8px;
            height: 24px;
          }
        }
        .fileInfo {
          margin-top: 3px;
          .fileName {
            color: #505050;
            font-size: 14px;
            margin-bottom: 12px;

            width: 200px;
            height: 16px;

            text-overflow: ellipsis;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            line-height: 16px;
            display: -webkit-box;
          }
          .fileSize {
            color: #bdbdbd;
            font-size: 12px;
          }
        }
        .handle {
          img {
            margin-left: 16px;
            cursor: pointer;
          }
        }
      }
    }
  }
  .btns {
    width: 100%;
    position: fixed;
    bottom: 0;
    height: 60px;
    background-color: #ffffff;
    line-height: 60px;
    text-align: center;

    .btn {
      width: 100px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      padding: 0;
    }
    .saveBtn {
      border: 1px solid #e9e9e9;
      background: #ffffff;
      color: #bdbdbd;
    }
    .submitBtn {
      color: #ffffff;
      background: #db1c1b;
    }

    .absolute-button {
      position: absolute;
      left: 24px;
      top: 17px;
      color: #db1c1b;
    }
  }
}
::v-deep {
  .el-form-item__content {
    // width: 342px;
    display: flex;
    align-items: center;
  }
  .el-row {
    display: flex;
    flex-wrap: wrap;
  }
  .el-form-item {
    margin-bottom: 18px;
  }
}

.fq-data {
  .el-form-item {
    // width: 33.33%;
  }

  .gray {
    color: #bdbdbd;
  }
}

/deep/ .el-radio__input.is-checked .el-radio__inner {
  border-color: #db1c1b;
  background: #db1c1b;
}
/deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #db1c1b;
}

.el-radio {
  margin-right: 4px;
}

.variablList {
  // width: 50%;
}

.formItemDscp {
  font-size: 12px;
  line-height: 40px;
  width: 64px;
  // max-width: 84px;
  overflow: hidden;
  height: 40px;
  margin-left: 4px;
  text-align: right;
}
</style>
